import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

import styles from "../styles/components/Navbar.module.css";
import logo from "../assets/logo.png";
import whiteLogo from "../assets/amritjal_hp/dharmik_white_logo.png"
import logoIcon from "../assets/logo_icon.png";
import instagram from "../assets/sm_icon/Instagram.png"

const NavBar = ({ bookPujaRef }) => {
  const [phone, setPhone] = useState(null);
  const [language, setLanguage] = useState("en");
  const [navLangText, setNavLangText] = useState("हिन्दी");
  const [showDropdown, setShowDropdown] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [mobileOfferingsOpen, setMobileOfferingsOpen] = useState(false);

  const navigate = useNavigate();
  const { t, i18n } = useTranslation();

  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);

  useEffect(() => {
    const phone = JSON.parse(localStorage.getItem("phoneNumber"));
    if (phone) {
      setPhone(phone);
    }
    const language = JSON.parse(localStorage.getItem("language"));
    if (!language) {
      localStorage.setItem("language", JSON.stringify("en"));
      setLanguage("en");
    } else {
      setLanguage(language);
      toggleLangText();
    }
  }, [language]);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 768) {
        setIsMenuOpen(false);
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const toggleLangText = () => {
    const navLang = JSON.parse(localStorage.getItem("language"));
    setNavLangText(navLang === "en" ? "हिन्दी" : "English");
  };

  const handlePujaClick = () => {
    navigate("/");
    bookPujaRef?.current.scrollIntoView({ behavior: "smooth" });
  };

  const handleSectionNavigation = (sectionId) => {
    navigate("/");
    setTimeout(() => {
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }, 100);
    setShowDropdown(false);
    setIsMenuOpen(false);
  };

  const toggleLanguage = () => {
    const newLanguage = language === "en" ? "hi" : "en";
    localStorage.setItem("language", JSON.stringify(newLanguage));
    setLanguage(newLanguage);
    i18n.changeLanguage(newLanguage);
  };

  return (
    <>
      {/* Desktop Nav */}
      <div className={styles.navigation}>
        <a href="/" className={styles.desktopOnly}>
          <img src={logoIcon} alt="Dharmik Icon" className={styles.logo} />
          <img src={logo} alt="Dharmik Logo" className={styles.logo} />
        </a>

        <div className={styles.desktopOnly}>
          <div className={styles.nav_links}>
            <div
              className={styles.dropdown}
              onMouseEnter={() => setShowDropdown(true)}
              onMouseLeave={() => setShowDropdown(false)}
            >
              <span className={styles.download_button}>
                {t("Offerings")} &#9662;
              </span>
              {showDropdown && (
                <div className={styles.dropdownContent}>
                  <button onClick={() => handleSectionNavigation("limited-launches")}>Limited Launches</button>
                  <button onClick={() => handleSectionNavigation("mahakumbh-jal")}>MahaKumbh Jal</button>
                  <button onClick={() => handleSectionNavigation("rishikesh-getaway")}>Rishikesh Getaway</button>
                  <button onClick={() => handleSectionNavigation("prasad-boxes")}>Prasad Boxes & Gifts</button>
                  <button onClick={() => handleSectionNavigation("book-puja")}>Book Pujas</button>
                </div>
              )}
            </div>

            <b onClick={handlePujaClick} className={styles.navbar_pujas}>
              {t("Pujas")}
            </b>
            <a href="https://blogs.dharmikapp.in" className={styles.navbar_pujas}>
              {t("Blogs")}
            </a>
            <a href="/contact-us" className={styles.navbar_pujas}>
              {t("Contact Us")}
            </a>
            <b className={styles.download_button} onClick={toggleLanguage}>
              {navLangText}
            </b>
            <b
              className={styles.download_button}
              onClick={() =>
                window.open(
                  "https://play.google.com/store/apps/details?id=in.gharkamandir.gharkamandir"
                )
              }
            >
              {t("Download App")}
            </b>
            {phone ? (
              <a href="/profile" className={styles.navbar_pujas}>
                {t("profile")}
              </a>
            ) : (
              <button
                onClick={() => navigate("/login")}
                className={styles.login_button}
              >
                {t("Login")}
              </button>
            )}
          </div>
        </div>

        {/* Mobile Nav */}
        <div className={styles.mobileOnly}>
          <button className={styles.hamburger} onClick={toggleMenu}>
            ☰
          </button>
          
          <a href="/" className={styles.mobileLogo}>
            <img src={logoIcon} alt="Dharmik Icon" className={styles.logo} />
            <img src={logo} alt="Dharmik Logo" className={styles.logo} />
          </a>
          
          {phone ? (
            <a href="/profile" className={styles.navbar_pujas}>
              {t("profile")}
            </a>
          ) : (
            <button
              onClick={() => navigate("/login")}
              className={styles.login_button}
            >
              {t("Login")}
            </button>
          )}
        </div>
      </div>

      {/* Side Drawer Menu */}
      {isMenuOpen && (
        <div className={styles.sideMenu}>
          <div className={styles.sideMenuHeader}>
            <span onClick={toggleMenu} className={styles.closeIcon}>
              ✕
            </span>
            <img src={whiteLogo} alt="Dharmik Logo" className={styles.logo} />
          </div>

          <div className={styles.sideMenuContent}>
            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
            <a 
              className={styles.navbar_pujas}
              onClick={() => setMobileOfferingsOpen(!mobileOfferingsOpen)}
            >
              Offerings {mobileOfferingsOpen ? "▼" : "►"}
            </a>
            {mobileOfferingsOpen && (
              <div className={styles.mobileDropdown}>
                <button onClick={() => handleSectionNavigation("limited-launches")}>Limited Launches</button>
                <button onClick={() => handleSectionNavigation("mahakumbh-jal")}>MahaKumbh Jal</button>
                <button onClick={() => handleSectionNavigation("rishikesh-getaway")}>Rishikesh Getaway</button>
                <button onClick={() => handleSectionNavigation("prasad-boxes")}>Prasad Boxes & Gifts</button>
                <button onClick={() => handleSectionNavigation("book-puja")}>Book Pujas</button>
              </div>
            )}

            <a href="https://blogs.dharmikapp.in" className={styles.navbar_pujas}>Blogs</a>
            {phone && <a href="/profile" className={styles.navbar_pujas}>Profile</a>}
            <a href="/contact-us" className={styles.navbar_pujas}>Contact Us</a>

            <div className={styles.contactSection}>
              <img src={instagram} alt="" />
              <p 
                onClick={() => window.open("https://www.instagram.com/dharmik_app/")}
                style={{ cursor: "pointer" }}
              >
                /dharmik_app</p>
            </div>
            <p style={{margin: "0", marginLeft: "2rem"}}>+91 7906671664</p>

            <p className={styles.footerNote}>
              "Blending Spirituality with Modernism"
            </p>
          </div>
        </div>
      )}
    </>
  );
};

export default NavBar;
